import React from "react";

import htmlIcon from "../assets/icons/skills/html5.svg";
import cssIcon from "../assets/icons/skills/css3.svg";
import jsIcon from "../assets/icons/skills/javascript.svg";
import reactIcon from "../assets/icons/skills/react.svg";
import pythonIcon from "../assets/icons/skills/python.svg";
import javaIcon from "../assets/icons/skills/java.svg";
import gitIcon from "../assets/icons/skills/git.svg";
import githubIcon from "../assets/icons/skills/github.svg";
import markdownIcon from "../assets/icons/skills/markdown.svg";
import sphinxIcon from "../assets/icons/skills/sphinx.svg";

const icons = [
  { icon: htmlIcon, label: "HTML" },
  { icon: cssIcon, label: "CSS" },
  { icon: jsIcon, label: "JavaScript" },
  { icon: reactIcon, label: "React" },
  { icon: pythonIcon, label: "Python" },
  { icon: javaIcon, label: "Java" },
  { icon: gitIcon, label: "Git" },
  { icon: githubIcon, label: "GitHub", invert: true },
  { icon: markdownIcon, label: "Markdown" },
  { icon: sphinxIcon, label: "Sphinx", invert: true },
];

const competencies = [
  "Markdown",
  "Docs-as-Code",
  "Information Architecture",
  "Content Strategy",
];

const Skills = () => {
  return (
    <div name="skills" className="w-full bg-[#0a192f] text-gray-300 py-16">
      <div className="max-w-[1000px] mx-auto px-4 flex flex-col items-center">
        <p className="text-4xl font-bold inline border-b-4 border-cyan-500 text-center mb-4">
          Skills
        </p>
        <p className="text-center py-4 text-xl text-gray-400 max-w-[600px]">
          Technologies and tools I build and write with:
        </p>

        {/* Scrolling icon marquee */}
        <div className="w-full overflow-hidden mt-8">
          <div className="flex marquee-track" style={{ width: "200%" }}>
            {[...icons, ...icons].map(({ icon, label, invert }, i) => (
              <div
                key={i}
                className="flex flex-col items-center gap-2 cursor-default flex-shrink-0 px-8"
              >
                <img src={icon} alt={label} className="w-10 h-10" style={invert ? { filter: "invert(1)" } : {}} />
                <span className="text-xs text-gray-400">{label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="w-full border-t border-gray-800 my-10" />

        {/* Competencies as text badges */}
        <div className="w-full">
          <p className="text-xs font-semibold uppercase tracking-widest text-gray-500 text-center mb-6">
            Core Competencies
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            {competencies.map((skill) => (
              <span
                key={skill}
                className="text-sm bg-[#112240] text-cyan-400 border border-cyan-900 px-4 py-2 rounded-full hover:border-cyan-500 hover:text-cyan-300 transition-colors duration-300 cursor-default"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
